import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../Hero/Hero";
import Main from "../Main/Main";
import "../../../src/App.css";
import GamesImages from "../GamesImages/GamesImages";
import UpcomingEvents from "../UpcomingEvents/UpcomingEvents";
import Footer from "../Footer/Footer";
import Header from "../header/Header";
import AuthPopup from "../AuthPopup/AuthPopup";
import ExposureHeader from "../ExposureHeader/ExposureHeader";
import Offcanvas from "react-bootstrap/Offcanvas";
import Empty from "../EmptyDiv/Empty";
import ScrollCasino from "../ScrollCasino/ScrollCasino";
import ScrollGames from "../ScrollGames/ScrollGames";
import News from "../News/news";
import DepositWithdraw from "../DepositWithdraw";
import Helper from "../../helper";
import SideMenu from "../SideMenu/SideMenu";
import OpenBets from "../OpenBets/OpenBets";
import Othercasino from "../OtherCasino/Othercasino";
import Indiancardgames from "../IndianCardGames/Indiancardgames";
import UpcomingEventsSecond from "../UpcomingEventsSecond/UpcomingEventsSecond";
import Appconfig from "../../config/config";
import axios from "axios";
import { FaWhatsapp } from "react-icons/fa";

const MainScreen = () => {
  const userInfo = Helper();
  const location = useLocation();

  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  const [eventType, setEventType] = useState(undefined);
  const [showMenu, setShowMenu] = useState(false);
  const [events, setEvents] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [whatsappNum, setWhatsAppNumber] = useState("");

  const upcomingEventsRef = useRef(null); // 👈 Create ref

  // Sync eventType from navigation state
  useEffect(() => {
    if (location.state && location.state.eventType !== undefined) {
      setEventType(location.state.eventType);
    }
  }, [location.state]);

  // 👇 Scroll to UpcomingEvents when eventType changes
  useEffect(() => {
    if (eventType && upcomingEventsRef.current) {
      const yOffset = isMobile ? 140 : 100;
      const y =
        upcomingEventsRef.current.getBoundingClientRect().top +
        window.pageYOffset -
        yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, [eventType, isMobile]);

  // Resize handler
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll to Indian Card Games when navigated via pathname
  useEffect(() => {
    if (location.pathname === "/indiancardgames") {
      const el = document.getElementById("indiancardgames");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const handleToggleMenu = () => setShowMenu((prev) => !prev);

  useEffect(() => {
    getWhatsAppNumber();
  }, []);

  const getWhatsAppNumber = () => {
    var data = JSON.stringify({
      site_code: Appconfig.sitecodes,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}numbers/getNumberBySiteCode`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          if (response.data.result) {
            setWhatsAppNumber(response.data?.resultData?.mob_num);
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        // postErrorToslack(error.message);
        console.log(error);
      });
  };

  return (
    <div>
      <Header
        showMenu={showMenu}
        handleToggleMenu={handleToggleMenu}
        isMobile={isMobile}
        whatsappNum={whatsappNum}
      />

      <div style={{ position: "fixed", zIndex: "2", width: "100%" }}>
        <ScrollGames
          setEventType={setEventType}
          eventType={eventType}
          isMobile={isMobile}
        />
      </div>

      <div className="main-content-wrapper">
        {isMobile ? (
          <>
            <div style={{ width: "100%" }}>
              <News />
              <Main />
              <Othercasino />
              {/* Wrap UpcomingEvents with ref 👇 */}
              <div ref={upcomingEventsRef}>
                <UpcomingEvents eventType={eventType} />
              </div>
              <ScrollCasino />
              <div id="indiancardgames">
                <Indiancardgames />
              </div>
            </div>

            {/* Mobile Side Menu */}
            <div
              className="sidemenu-overlay"
              style={{ display: showMenu ? "block" : "none" }}
              onClick={() => setShowMenu(false)}
            />
            <div
              className={`sidemenu-mobile${showMenu ? " open" : ""}`}
              onClick={(e) => e.stopPropagation()}
            >
              <SideMenu
                handleToggleMenu={handleToggleMenu}
                isMobile={isMobile}
                whatsappNum={whatsappNum}
                props={{ setEventType }}
              />
            </div>
          </>
        ) : (
          <div className="mainscreen-container">
            <div>
              <SideMenu
                handleToggleMenu={handleToggleMenu}
                isMobile={isMobile}
                props={{ setEventType }}
              />
            </div>
            <div style={{ width: "50%" }}>
              <News />
              <Main />
              <Othercasino />
              {/* Wrap UpcomingEvents with ref 👇 */}
              <div ref={upcomingEventsRef}>
                <UpcomingEvents eventType={eventType} />
              </div>
              <ScrollCasino />
              <div id="indiancardgames">
                <Indiancardgames />
              </div>
            </div>
            <div style={{ width: "30%" }}>
              <OpenBets />
            </div>
          </div>
        )}
      </div>

      <Footer />

        {/* WhatsApp Floating Icon */}
    {whatsappNum && (
      <a
        href={`https://wa.me/${whatsappNum}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          bottom: "24px",
          right: "24px",
          zIndex: 1000,
          background: "#25D366",
          borderRadius: "50%",
          width: "56px",
          height: "56px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        }}
        title="Chat on WhatsApp"
      >
        <FaWhatsapp size={32} color="#fff" />
      </a>
    )}

    </div>
  );
};

export default MainScreen;
